export const ARTICLE_CREATE_REQUEST = 'ARTICLE_CREATE_REQUEST';
export const ARTICLE_CREATE_SUCCESS = 'ARTICLE_CREATE_SUCCESS';
export const ARTICLE_CREATE_FAIL = 'ARTICLE_CREATE_FAIL';

export const ARTICLE_GET_REQUEST = 'ARTICLE_GET_REQUEST';
export const ARTICLE_GET_SUCCESS = 'ARTICLE_GET_SUCCESS';
export const ARTICLE_GET_FAIL = 'ARTICLE_GET_FAIL';

export const ARTICLE_SEARCH_REQUEST = 'ARTICLE_SEARCH_REQUEST';
export const ARTICLE_SEARCH_SUCCESS = 'ARTICLE_SEARCH_SUCCESS';
export const ARTICLE_SEARCH_FAIL = 'ARTICLE_SEARCH_FAIL';
export const ARTICLE_SEARCH_RESET = 'ARTICLE_SEARCH_RESET';
